import { Breadcrumb, Typography } from "antd";

const { Text, Link } = Typography;

export const MachineBreadcrumbs = (id, machine) => {
   return (
      <Breadcrumb
         items={[
            {
               title: <Link href={`/${machine}/orders`}>Orders</Link>,
            },
            {
               title: <Text>{id}</Text>,
            },
         ]}
      />
   );
};
